<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<ng-container *ngIf="isLoading; else mainContent">
  <div class="spinner-container"><mat-spinner></mat-spinner></div>
</ng-container>

<ng-template #mainContent>
  <div class="page">
    <div class="container">

      <!-- Cabeçalho -->
      <section class="section-kits">
        <h2 class="title">Revisão editorial</h2>
        <p class="subtitle">Confirme e complete os dados obrigatórios para liberação do livro.</p>

        <div class="book-info">
          <div class="book-header" *ngIf="coverStyleFileName">
            <div>
              <img style="width: 250px;" [src]="coverStyleFileName || 'assets/images/book-placeholder.svg'" alt="Estilo de capa" />
                <p *ngIf="coverStyleFileName">Estilo de capa: <b>{{ coverStyleName || '—' }}</b></p>
            </div>
          </div>
          <!-- servicos contratados-->
          <div class="readonly-section">
            <div>
              <p class="author"><b>Serviços</b></p>
              <ul>
                <li *ngFor="let service of listService">{{ service }}</li>
              </ul>
              <p class="author"><b>Status</b></p>
                <p *ngIf="!bookForEbookLabel">❌ Arquivo do Ebook não carregado</p>
                <p *ngIf="!bookForPrintLabel">❌ Arquivo do miolo não carregado</p>
                <p *ngIf="!coverForPrintLabel">❌ Arquivo do capa (impressão) não carregado</p>
                <p *ngIf="!frontCoverPreview">❌ Imagem de capa da plataforma não carregada</p>
                <p *ngIf="!backCoverPreview">❌ Imagem de contracapa da plataforma não carregada</p>
                <p *ngIf="!form.controls.isbn || form.controls.isbn.invalid">❌ Isbn não preenchido ou inválido</p>
            </div>
          </div>
          <div class="book-header">
            <div class="cover-box" *ngIf="frontCoverPreview || backCoverPreview">
              <img [src]="frontCoverPreview || 'assets/images/book-placeholder.svg'" alt="Capa" />
              <img class="cover" [src]="backCoverPreview || 'assets/images/book-placeholder.svg'" alt="Contracapa" />
            </div>

            <div class="book-info-text">
              <h1>{{ bookTitle || '—' }}</h1>
              <p class="author">Por {{ authorName || '—' }}</p>

              <div class="action-buttons">
                <button mat-raised-button class="btn-primary button-login" type="button" (click)="openBookPreview()"
                  [disabled]="!bookAuthorFile">
                  Acessar arquivo do autor
                </button>

                <button mat-stroked-button type="button" [disabled]="!zipCoverFileName || !zipCoversBase64"
                  (click)="downloadZipFromServer()">
                  Baixar capas
                </button>

                <!-- Anchor não suporta disabled. Use button. -->
                <button mat-stroked-button type="button" [disabled]="!authorPhotoUrl"
                  (click)="openUrlInNewTab(authorPhotoUrl)">
                  Baixar foto do autor
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- RESUMO / CAMPOS EM TEXTO DO BOOKVERSION -->
      <section class="section-kits">
        <h2 class="title">Dados básicos</h2>

        <!-- DADOS BÁSICOS -->
        <div class="readonly-section">
          <h3 class="section-title">Dados básicos</h3>
          <div class="kv-grid">
            <div class="kv">
              <span class="k">Título</span>
              <span class="v">{{ bookVersion?.bookTitle || '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Subtítulo</span>
              <span class="v">{{ bookVersion?.bookSubtitle || '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Edição</span>
              <span class="v">{{ bookVersion?.versionName || '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Coleção</span>
              <span class="v">{{ bookVersion?.collectionName || '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Volume / nº da coleção</span>
              <span class="v">{{ bookVersion?.volumeName || '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Data da submissão</span>
              <span class="v">{{ bookVersion?.datetimeInclusion | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="kv">
              <span class="k">Data de publicação</span>
              <span class="v">
                {{ bookVersion?.publicationDate ? (bookVersion?.publicationDate | date:'dd/MM/yyyy') : '—' }}
              </span>
            </div>
          </div>
        </div>

        <!-- SINOPSE -->
        <div class="readonly-section">
          <h3 class="section-title">Sinopse</h3>
          <p class="multiline">{{ bookVersion?.synopsis || '—' }}</p>
          <div class="hint">{{ (bookVersion?.synopsis?.length || 0) }}/800</div>
        </div>

        <!-- AUTORES -->
        <div class="readonly-section">
          <h3 class="section-title">Autores</h3>
          <div class="kv-grid">
            <div class="kv">
              <span class="k">Autor principal (capa)</span>
              <span class="v">{{ bookVersion?.authorName || authorName || '—' }}</span>
            </div>

            <!-- Você não renderiza a lista, então não inventa placeholder vazio -->
            <div class="kv full">
              <span class="k">Demais autores</span>
              <span class="v">—</span>
            </div>
          </div>
        </div>

        <!-- BIO -->
        <div class="readonly-section">
          <h3 class="section-title">Biografia do autor</h3>
          <div class="bio-wrap">
            <div class="photo-mini">
              <!-- Use a URL tratada (authorPhotoUrl). Não mistura com bookVersion?.authorPhotoFileName -->
              <img *ngIf="authorPhotoUrl" [src]="authorPhotoUrl" [ngClass]="{
                  'photo-square': bookVersion?.idPhotoShape === 1,
                  'photo-round': bookVersion?.idPhotoShape === 2
                }" alt="Foto do autor" />

              <div *ngIf="!authorPhotoUrl" class="no-photo">Sem foto</div>
            </div>

            <div class="bio-text">
              <p class="multiline">{{ bookVersion?.authorBio || '—' }}</p>
              <div class="hint">{{ (bookVersion?.authorBio?.length || 0) }}/4000</div>
            </div>
          </div>
        </div>

        <!-- EPÍGRAFE -->
        <div class="readonly-section">
          <h3 class="section-title">Epígrafe</h3>
          <p class="multiline">{{ bookVersion?.preface || '—' }}</p>
          <div class="hint">{{ (bookVersion?.preface?.length || 0) }}/250</div>
        </div>

        <!-- OUTROS DADOS -->
        <div class="readonly-section">
          <h3 class="section-title">Outros dados</h3>
          <div class="kv-grid">
            <div class="kv">
              <span class="k">Categoria primária</span>
              <span class="v">{{ primaryCategoryName || '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Categoria secundária</span>
              <span class="v">{{ secondaryCategoryName || '—' }}</span>
            </div>

            <div class="kv full" *ngIf="bookVersion?.reasonReprove">
              <span class="k">Último motivo de reprovação</span>
              <span class="v warn">{{ bookVersion?.reasonReprove }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Dados obrigatórios -->
      <section class="section-kits" style="margin-top: -30px;">
        <form [formGroup]="form" class="row g-3">

          <h2 class="title">ISBN</h2>

          <!-- ISBN -->
          <mat-form-field appearance="outline" class="field col-12 col-md-6">
            <mat-label>ISBN</mat-label>
            <input matInput formControlName="isbn" maxlength="17" placeholder="978-85-0000-000-0" />
            <mat-hint>Somente números e hífens (10 ou 13 dígitos).</mat-hint>
            <mat-error *ngIf="form.controls.isbn.invalid && (form.controls.isbn.dirty || tried)">
              Informe um ISBN válido (10 ou 13 dígitos, pode conter hífens).
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field col-12 col-md-6">
            <mat-label>DOI</mat-label>
            <input matInput formControlName="doi" maxlength="500" placeholder="10.1007/978-1-4842-3630-7" />
            <mat-hint>Identificador de Objeto Digital (DOI)</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field col-12 col-md-6">
            <mat-label>Total de páginas (miolo)</mat-label>
            <input matInput formControlName="totalPages" maxlength="5" placeholder="100" />
            <mat-hint>Somente números.</mat-hint>
            <mat-error *ngIf="form.controls.totalPages.invalid && (form.controls.totalPages.dirty || tried)">
              Informe um número válido de páginas.
            </mat-error>
          </mat-form-field>

          <br />
          <h2 class="title" style="margin-top: 40px;">Capa (plataforma)</h2>
          <p class="subtitle">Capa exibida na plataforma</p>

          <!-- Upload CAPA -->
          <div class="col-12 col-md-4">
            <strong class="upload-title">Capa (imagem)</strong>
            <p class="upload-sub">Clique ou toque para alterar</p>

            <div class="upload-box" [class.has-preview]="!!frontCoverPreview" (click)="frontCoverInput.click()">
              <div class="empty-state" *ngIf="!frontCoverPreview">
                <strong class="upload-title">Capa (imagem)</strong>
                <p class="upload-sub">.jpg, .png, .webp — máx 5MB</p>
                <button type="button" mat-raised-button class="btn-primary button-login">Selecionar arquivo</button>
              </div>

              <img *ngIf="frontCoverPreview" class="upload-preview" [src]="frontCoverPreview" alt="Preview capa" />
            </div>

            <input #frontCoverInput type="file" accept="image/*" hidden (change)="onCoverPicked($event, 'front')" />
            <mat-hint *ngIf="!frontCoverPreview" class="text-warn">Obrigatório</mat-hint>
          </div>

          <!-- Upload CONTRACAPA -->
          <div class="col-12 col-md-4">
            <strong class="upload-title">Contracapa (imagem)</strong>
            <p class="upload-sub">Clique ou toque para alterar</p>

            <div class="upload-box" [class.has-preview]="!!backCoverPreview" (click)="backCoverInput.click()">
              <div class="empty-state" *ngIf="!backCoverPreview">
                <strong class="upload-title">Contracapa (imagem)</strong>
                <p class="upload-sub">.jpg, .png, .webp — máx 5MB</p>
                <button type="button" mat-raised-button class="btn-primary button-login">Selecionar arquivo</button>
              </div>

              <img *ngIf="backCoverPreview" class="upload-preview" [src]="backCoverPreview" alt="Preview contracapa" />
            </div>

            <input #backCoverInput type="file" accept="image/*" hidden (change)="onCoverPicked($event, 'back')" />
            <mat-hint *ngIf="!backCoverPreview" class="text-warn">Obrigatório</mat-hint>
          </div>

        </form>
      </section>

      <!-- Arquivos finais -->
      <section class="section-kits">
        <h2 class="title">Arquivos finais</h2>
        <p class="subtitle">Envie/valide os artefatos finais antes de aprovar a revisão.</p>

        <div class="row g-3 align-items-stretch">

          <!-- Capa para impressão (PDF) -->
          <div class="col-12 col-lg-4">
            <strong class="upload-title">Capa para impressão (PDF)</strong>
            <p class="upload-sub">Clique ou toque para alterar</p>

            <div class="upload-box h-100" [class.has-preview]="!!(coverForPrintLabel || files.coverForPrintUrl)"
              (click)="coverForPrintInput.click()">

              <div class="empty-state" *ngIf="!(coverForPrintLabel || files.coverForPrintUrl)">
                <strong class="upload-title">Capa para impressão (PDF)</strong>
                <p class="upload-sub">.pdf — máx 100MB</p>
                <button type="button" mat-raised-button class="btn-primary button-login">Selecionar arquivo</button>
              </div>

              <div class="upload-preview" *ngIf="coverForPrintLabel || files.coverForPrintUrl">
                <div class="file-row">
                  <span class="file-label">
                    {{ coverForPrintLabel || getFileNameFromUrl(files.coverForPrintUrl) || 'Arquivo pronto' }}
                  </span>

                  <!-- Só mostra abrir se ainda for o arquivo do servidor (quando base64 está null) -->
                  <button mat-icon-button type="button" *ngIf="files.coverForPrintUrl && !coverForPrintLabel"
                    (click)="openUrlInNewTab(files.coverForPrintUrl, $event)">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                </div>

                <small class="hint">Clique para substituir</small>
              </div>
            </div>

            <input #coverForPrintInput type="file" accept="application/pdf" hidden
              (change)="onFilePicked($event, 'coverForPrint')" />

            <mat-hint *ngIf="!(coverForPrintLabel || files.coverForPrintUrl)" class="text-warn">Obrigatório</mat-hint>
          </div>

          <!-- Livro para imprimir (PDF) -->
          <div class="col-12 col-lg-4">
            <strong class="upload-title">Miolo da impressão (PDF)</strong>
            <p class="upload-sub">Clique ou toque para alterar</p>

            <div class="upload-box h-100" [class.has-preview]="!!(bookForPrintLabel || files.bookForPrintUrl)"
              (click)="bookForPrintInput.click()">

              <div class="empty-state" *ngIf="!(bookForPrintLabel || files.bookForPrintUrl)">
                <strong class="upload-title">Miolo da impressão (PDF)</strong>
                <p class="upload-sub">.pdf — máx 500MB</p>
                <button type="button" mat-raised-button class="btn-primary button-login">Selecionar arquivo</button>
              </div>

              <div class="upload-preview" *ngIf="bookForPrintLabel || files.bookForPrintUrl">
                <div class="file-row">
                  <span class="file-label">
                    {{ bookForPrintLabel || getFileNameFromUrl(files.bookForPrintUrl) || 'Arquivo pronto' }}
                  </span>

                  <button mat-icon-button type="button" *ngIf="files.bookForPrintUrl && !bookForPrintLabel"
                    (click)="openUrlInNewTab(files.bookForPrintUrl, $event)">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                </div>

                <small class="hint">Clique para substituir</small>
              </div>
            </div>

            <input #bookForPrintInput type="file" accept="application/pdf" hidden
              (change)="onFilePicked($event, 'bookForPrint')" />

            <mat-hint *ngIf="!(bookForPrintLabel || files.bookForPrintUrl)" class="text-warn">Obrigatório</mat-hint>
          </div>

          <!-- Livro para e-book -->
          <div class="col-12 col-lg-4">
            <strong class="upload-title">Arquivo do e-book (EPUB/PDF)</strong>
            <p class="upload-sub">Clique ou toque para alterar</p>

            <div class="upload-box h-100" [class.has-preview]="!!(bookForEbookLabel || files.bookForEbookUrl)"
              (click)="bookForEbookInput.click()">

              <div class="empty-state" *ngIf="!(bookForEbookLabel || files.bookForEbookUrl)">
                <strong class="upload-title">Arquivo do e-book (EPUB/PDF)</strong>
                <p class="upload-sub">.epub ou .pdf — máx 500MB</p>
                <button type="button" mat-raised-button class="btn-primary button-login">Selecionar arquivo</button>
              </div>

              <div class="upload-preview" *ngIf="bookForEbookLabel || files.bookForEbookUrl">
                <div class="file-row">
                  <span class="file-label">
                    {{ bookForEbookLabel || getFileNameFromUrl(files.bookForEbookUrl) || 'Arquivo pronto' }}
                  </span>

                  <button mat-icon-button type="button" *ngIf="files.bookForEbookUrl && !bookForEbookLabel"
                    (click)="openUrlInNewTab(files.bookForEbookUrl, $event)">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                </div>

                <small class="hint">Clique para substituir</small>
              </div>
            </div>

            <input #bookForEbookInput type="file" accept="application/epub+zip,application/pdf" hidden
              (change)="onFilePicked($event, 'bookForEbook')" />

            <mat-hint *ngIf="!(bookForEbookLabel || files.bookForEbookUrl)" class="text-warn">Obrigatório</mat-hint>
          </div>

        </div>
      </section>

      <!-- Ações -->
      <section class="details-actions">
        <button mat-stroked-button type="button" color="primary" (click)="goBack()">Voltar</button>

        <button *ngIf="reviewingStatus" mat-stroked-button type="button" (click)="saveForLater()">
          Salvar e continuar depois
        </button>

        <button *ngIf="reviewingStatus" mat-stroked-button type="button" color="warn" (click)="openRejectDialog()">
          Reprovar revisão
        </button>

        <button *ngIf="reviewingStatus" mat-raised-button type="button" class="btn-primary button-login"
          (click)="approve()" [disabled]="!canApprove">
          Aprovar revisão
        </button>
      </section>

      <section class="details-actions" *ngIf="!reviewingStatus">
        <span class="info-text" style="color: red; text-align: center;">
          O livro selecionado não está em fase de revisão.
          <br />
          Nenhuma alteração será salva
        </span>
      </section>

    </div>
  </div>
</ng-template>

<app-footer></app-footer>